export const tableContainerSx = {
    borderRadius: 2,
    // Completely remove height restrictions and let table expand naturally
    height: "auto",
    maxHeight: "none", 
    // wide tables scroll sideways inside their card instead of stretching the whole page
    overflowX: "auto",
    "& .MuiTable-root": {
      minWidth: "100%",
      height: "auto",
    },
    // Ensure no scroll constraints from Material-UI defaults
    "& .MuiTableContainer-root": {
      overflow: "visible",
      maxHeight: "none",
    },
  };

// Legacy fixed-height version (keep for compatibility if needed)
export const fixedTableContainerSx = {
    maxHeight: 700,
    borderRadius: 2,
    overflowY: "auto",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": { width: 0 },
    "&:hover::-webkit-scrollbar": { width: "6px" },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: "#555",
      borderRadius: "4px",
    },
    "&:hover::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
  };
  